import React, { Component, Fragment } from 'react'
import { BrowserRouter, Link, Route, Router } from 'react-router-dom'
import Film_CreateCode from './Component/Film/Flim_CreateCode'
import Acc_CreateItem from './Component/Acc/Acc_CreateItem'
import Acc_EditItem from './Component/Acc/Acc_EditItem'
import Acc_PreviewBomVer from './Component/Acc/Acc_PreviewBomVer'
import Acc_PreviewBomLine from './Component/Acc/Acc_PreviewBomLine'
import Acc_CreateBom from './Component/Acc/Acc_CreateBom'
import Acc_EditBom from './Component/Acc/Acc_EditBom'
import Acc_EditBomline from './Component/Acc/Acc_EditBomLine'
import Acc_PreviewItem from './Component/Acc/Acc_PreviewItem'
import Film_TempItem from './Component/Film/Flim_TempItem'
import Film_PreviewItem from './Component/Film/Flim_PreviewItem'
import Flim_EditItem from './Component/Film/Flim_EditItem'
import Film_PreviewBomVer from './Component/Film/Flim_PreviewBomVer'
import Film_CreateBomVer from './Component/Film/Flim_CreateBomVer'
import Film_PreviewBomLine from './Component/Film/Flim_PreviewBomLine'
import Film_EditBomVersion from './Component/Film/Flim_EditBomVersion'
import Film_EditBomLine from './Component/Film/Flim_EditBomLine'
import Film_MasterBomLine from './Component/Film/Master/Film_MasterBomLine'
import Film_AddMasterBomLine from './Component/Film/Master/Flim_AddMasterBomLine'
import Film_EditMasterBomLine from './Component/Film/Master/Flim_EditMasterBomLine'
import Film_MasterFocusTrade from './Component/Film/Master/Film_MasterFocusTrade'
import Film_EditMasterFocusTrade from './Component/Film/Master/Flim_EditMasterFocusTrade'
import Film_MasterStandard from './Component/Film/Master/Film_MasterStandard'
import Film_EditMasterStandard from './Component/Film/Master/Flim_EditMasterStandard'
import Film_MasterWerehouse from './Component/Film/Master/Film_MasterWerehouse'
import Film_EditMasterWerehouse from './Component/Film/Master/Flim_EditMasterWerehouse'
import Film_MasterOption from './Component/Film/Master/Film_MasterOption'
import Film_EditMasterOption from './Component/Film/Master/Flim_EditMasterOption'
import Film_MasterDataMin from './Component/Film/Master/Film_MasterDataMin'
import Film_EditMasterDataMin from './Component/Film/Master/Flim_EditMasterDataMin'
import Acc_MasterOption from './Component/Acc/Master/Acc_MasterOption'
import Acc_EditMasterOption from './Component/Acc/Master/Acc_EditMasterOption'
import Flim_ManageProductImage from './Component/Film/Flim_ManageProductImage'
import Film_DisplayProductImage from './Component/Film/Flim_DisplayProductImage'
import Film_DisplayTableProductImage from './Component/Film/Flim_DisplayTableProductImage'
import Flim_ManageProductImageGroup from './Component/Film/Flim_ManageProductImageGroup'
import Film_DisplayProductByGroup from './Component/Film/Film_DisplayProductByGroup'
import Film_DisplaySameModel from './Component/Film/Film_DisplaySameModel'


import Login from '../src/Login'

export default class extends Component {
  render() {
    return (
      <div>
        <Route exact path="/Acc" component={Acc_CreateItem} />
        <Route exact path="/Acc/CreateItem" component={Acc_CreateItem} />
        <Route exact path="/Acc/EditItem" component={Acc_EditItem} />
        <Route exact path="/Acc/PreviewItem" component={Acc_PreviewItem} />
        <Route exact path="/Acc/CreateBom" component={Acc_CreateBom} />
        <Route exact path="/Acc/EditBom" component={Acc_EditBom} />
        <Route exact path="/Acc/PreviewBomVer" component={Acc_PreviewBomVer} />
        <Route exact path="/Acc/PreviewBomline" component={Acc_PreviewBomLine} />
        <Route exact path="/Acc/EditBomline" component={Acc_EditBomline} />
        <Route exact path="/Acc/MasterOption" component={Acc_MasterOption} />
        <Route exact path="/Acc/editMasterOption" component={Acc_EditMasterOption} />

        <Route exact path="/" component={Login} />
        <Route exact path="/Login" component={Login} />
        <Route exact path="/Flim" component={Film_CreateCode} />
        <Route exact path="/Flim/CreateCode" component={Film_CreateCode} />
        <Route exact path="/Flim/TempItem" component={Film_TempItem} />
        <Route exact path="/Flim/PreviewItem" component={Film_PreviewItem} />
        <Route exact path="/Flim/EditItem" component={Flim_EditItem} />
        <Route exact path="/Flim/CreateBomVer" component={Film_CreateBomVer} />
        <Route exact path="/Flim/PreviewBomVer" component={Film_PreviewBomVer} />
        <Route exact path="/Flim/PreviewBomLine" component={Film_PreviewBomLine} />
        <Route exact path="/Flim/MasterBomLine" component={Film_MasterBomLine} />
        <Route exact path="/Flim/EditBomVersion" component={Film_EditBomVersion} />
        <Route exact path="/Flim/EditBomLine" component={Film_EditBomLine} />
        <Route exact path="/Flim/addMasterBomline" component={Film_AddMasterBomLine} />
        <Route exact path="/Flim/editMasterBomline" component={Film_EditMasterBomLine} />
        <Route exact path="/Flim/MasterFocusTrade" component={Film_MasterFocusTrade} />
        <Route exact path="/Flim/editMasterFocusTrade" component={Film_EditMasterFocusTrade} />
        <Route exact path="/Flim/MasterStandard" component={Film_MasterStandard} />
        <Route exact path="/Flim/editMasterStandard" component={Film_EditMasterStandard} />
        <Route exact path="/Flim/MasterWerehouse" component={Film_MasterWerehouse} />
        <Route exact path="/Flim/editMasterWerehouse" component={Film_EditMasterWerehouse} />
        <Route exact path="/Flim/MasterOption" component={Film_MasterOption} />
        <Route exact path="/Flim/editMasterOption" component={Film_EditMasterOption} />
        <Route exact path="/Flim/MasterDataMin" component={Film_MasterDataMin} />
        <Route exact path="/Flim/editMasterDataMin" component={Film_EditMasterDataMin} />
        <Route exact path="/Flim/ManageProductImage" component={Flim_ManageProductImage} />
        <Route exact path="/Flim/ProductInfo" component={Film_DisplayProductImage} />
        <Route exact path="/Flim/ProductInfoTable" component={Film_DisplayTableProductImage} />
        <Route exact path="/Flim/ManageProductImageGroup" component={Flim_ManageProductImageGroup} />
        <Route exact path="/Flim/ProductInfoGroup" component={Film_DisplayProductByGroup} />
        <Route exact path="/Flim/SameModelInfo" component={Film_DisplaySameModel} />
      </div>
    )

  }

}